import { PaletteColor, PaletteColorOptions, createTheme } from "@mui/material";
import { blue, green, red } from "@mui/material/colors";

declare module "@mui/material/styles" {
  interface Palette {
    liteColor: {
      foreColor: PaletteColor;
      backColor: PaletteColor;
    };
    darkColor: {
      foreColor: PaletteColor;
      backColor: PaletteColor;
    };
  }
  interface PaletteOptions {
    liteColor?: {
      foreColor?: PaletteColorOptions;
      backColor?: PaletteColorOptions;
    };
    darkColor?: {
      foreColor?: PaletteColorOptions;
      backColor?: PaletteColorOptions;
    };
  }

  // Extending PaletteColorOptions and PaletteColor to include medium
  interface PaletteColorOptions {
    medium?: string; // Add medium to PaletteColorOptions
    main?: string;
    light?: string;
    dark?: string;
    tableHeader?: string;
    tableRowAdd?: string;
    tableRowEven?: string;
    disabled?: string;
  }

  interface PaletteColor {
    medium: string; // Add medium to PaletteColor
    main: string;
    light: string;
    dark: string;
    tableHeader: string;
    tableRowAdd: string;
    tableRowEven: string;
    disabled: string;
  }
}

export const theme = createTheme({
  // typography: {
  //   fontFamily: '"Barlow Condensed", sans-serif',
  //   fontWeightRegular: 400,
  //   fontWeightMedium: 500,
  //   fontWeightBold: 700,
  // },
  palette: {
    primary: {
      light: "#0adcc0",
      main: "#0adcc0",
      dark: "#0adcc0",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
    },
    liteColor: {
      foreColor: {
        main: "#019f6d", // 主要な背景色
        light: "#0adc93", // 明るいバリエーション
        dark: "#006f66", // 暗いバリエーション
      },
      backColor: {
        main: "#F0F2F5", // 主要な背景色
        light: "#FFF", // 明るいバリエーション
        medium: "#dcdcdc",
        dark: "#202226", // 暗いバリエーション
        tableHeader: "#4B4B4B",
        tableRowAdd: "#F0F2F5",
        tableRowEven: "#dcdcdc",
        disabled: "#a1a1a1",
      },
    },
    darkColor: {
      foreColor: {
        main: "#0adcc0", // 主要な背景色
        light: "#b3fea1", // 明るいバリエーション
        dark: "#00556f", // 暗いバリエーション
      },
      backColor: {
        main: "#2F3137", // 主要な背景色
        light: "#37393F", // 明るいバリエーション
        dark: "#202226", // 暗いバリエーション
        tableHeader: "#202226",
        tableRowAdd: "##37393F",
        tableRowEven: "#2F3137",
        disabled: "#a1a1a1",
      },
    },
  },
});
